<script setup lang="ts">
import type AntiRobot from '@/components/base/form/AntiRobot.vue';

type Props = {
  disabled: boolean;
  isDocsStep?: boolean;
  label?: string;
};

const { disabled, isDocsStep = false } = defineProps<Props>();

const emit = defineEmits(['submit']);

const {
  isCaptchaRegisterEnabled,
  isCaptchaValidateCpfEnabled,
  isInvisibleCaptcha,
} = useCaptcha();

const antiRobotRef = ref<InstanceType<typeof AntiRobot> | null>(null);
const antiRobotToken = computed<string>(
  () => antiRobotRef.value?.finalCaptchaTokenValue ?? '',
);

const isCaptchaVisible = computed(() => {
  if (isCaptchaValidateCpfEnabled.value && isDocsStep) {
    return true;
  }

  return isCaptchaRegisterEnabled.value;
});

function submit() {
  emit('submit');
}

function $resetAllCaptcha() {
  antiRobotRef.value?.$resetAllCaptcha();
}

defineExpose({
  antiRobotToken,
  $resetAllCaptcha,
});
</script>

<template>
  <div :class="$style.buttonContainer">
    <button
      :class="[$style.submitBtn, 'btn-primary']"
      :disabled="disabled"
      @click.prevent="submit"
    >
      {{ label ? label : $t('verification.gps.proceed') }}
      <NuxtIcon name="arrows/angle_right" />
    </button>

    <div
      v-if="isCaptchaVisible"
      :class="[
        $style.antiRobotContainer,
        { [$style.turnstileAlwaysShow]: !isInvisibleCaptcha },
      ]"
    >
      <BaseFormAntiRobot ref="antiRobotRef" />
    </div>
  </div>
</template>

<style module lang="scss">
.buttonContainer {
  @apply relative mt-2 w-full;

  .submitBtn {
    @apply mx-auto w-auto rounded-md gap-1.5 flex items-center font-bold uppercase py-2.5 focus:outline-none focus:ring-4;
  }
  .antiRobotContainer {
    @apply whitespace-nowrap;

    &.turnstileAlwaysShow {
      @apply min-h-20 mt-6 -mb-4;
    }
  }
}
</style>
